import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function AddToHomeScreenButton() {
  const [promptEvent, setPromptEvent] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPromptEvent = (e) => {
      // Prevent Chrome's built-in prompt from appearing
      e.preventDefault();
      // Stash the event so it can be triggered later
      setPromptEvent(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPromptEvent);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPromptEvent);
    };
  }, []);

  const handleAddToHomeScreenClick = () => {
    if (promptEvent) {
      // Show the browser's add to home screen prompt
      promptEvent.prompt();
      // Wait for the user to interact with the prompt
      promptEvent.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          // The user added the PWA to their home screen
          console.log('User added the PWA to their home screen');
        } else {
          // The user declined to add the PWA to their home screen
          console.log("User didn't add the PWA to their home screen");
        }
        // Reset the prompt event
        setPromptEvent(null);
      });
    }
  };

  return (
    <Link to="" className="withIcon1" onClick={handleAddToHomeScreenClick}>
      <p className="box32">
        <span className="icon-iconinstall heading-2 grey-3"></span>
      </p>
      <p className="yekan subject-1">نصب برنامه</p>
    </Link>
  );
}
export default AddToHomeScreenButton;
